export const BLUE = "#123D5B";
export const BLUE_DARKER = "#0C2F47";
export const BLUE_LIGHTER = "#327cb0";
